


















































import {Vue, Component} from 'vue-property-decorator';
import {addClass, removeClass} from '@/utils/classUtils';
import ItemTable from '@/components/common/ItemTable.vue';
import ExcelCreateButton from '@/components/common/grid/ExcelCreateButton.vue';
import {changeDateFormat} from '@/utils/dateUtils';
import {i18nInObjectList, i18nAllObject} from '@/utils/i18n';
import {GetCouponsCouponNoSummaryRequest} from 'supporter';
import {popupResize} from '@/utils/ncp';
import {writeExcel} from '@/utils/excel';
@Component({
  components: {
    ItemTable,
    ExcelCreateButton
  }
})
export default class CouponUseListPopup extends Vue {
  private paramsSearch = {};
  private get extraInfo() {
    return this.$route.query.couponNo;
  }
  private totalCount: number = 0;
  private initPageSize: number = 30;
  private couponContent: any = [];
  private couponInfo: object = {};
  private couponSummary: object = {};
  private contentBottomOption: any = {
    nonDataBodyHeight: 130,
    haveDataBodyHeight: 130,
    autoHeight: true,
    haveConfigBtn: true,
    haveExcelDownBtn: false
  };
  private size: number = 30;
  private created(): void {
    this.gridProps = i18nInObjectList(this, this.gridProps, 'columns', 'header');
  }
  private mounted() {
    addClass(document.body, 'popup_large');
    this.getCouponSummary();
    this.$nextTick(() => {
      popupResize();
    });
  }

  private beforeDestroy() {
    removeClass(document.body, 'popup_large');
  }
  private getCouponSummary(): void {
    let requset: GetCouponsCouponNoSummaryRequest = {
      pathParams: {
        couponNo: this.$route.query.couponNo.toString()
      }
    };
    this.$api.getCouponsCouponNoSummary(requset).then((res) => {
      this.couponInfo = res.data;
      this.couponSummary = res.data.couponSummary;
    });
  }
  private search(page: number = 1, size?: number): void {
    if (size) {
      this.size = size;
    }
    let request: any = {
      params: {
        couponNos: this.$route.query.couponNo as any, //之后查看
        couponUseStatusType: 'USED',
        sortType: 'REGISTER_YMDT',
        page: page,
        size: this.size
      }
    };
    this.paramsSearch = JSON.parse(JSON.stringify(request.params));
    this.$api.getCouponsIssue(request).then((res: any) => {
      this.couponContent = res.data.contents;
      this.totalCount = res.data.totalCount;
      this.gridProps.options.pageOptions.page = page;
      this.gridProps.options.pageOptions.perPage = this.size;
      this.gridProps.options.pageOptions.totalCount = res.data.totalCount;
    });
  }
  private async excelDown() {
    let request: any = {
      params: {
        couponNos: this.$route.query.couponNo as any,
        couponUseStatusType: 'USED',
        sortType: 'REGISTER_YMDT',
        size: this.totalCount
      }
    };
    const {data} = await this.$api.getCouponsIssue(request);
    if (data.contents.length === 0) {
      alert(this.$t('COMMON_NOT_DATA'));
    } else {
      let keyMapJson = {
        mallName: 'PROMOTION_POPUP_USELIST_HEADER_MALL_NAME',
        couponNo: 'PROMOTION_POPUP_USELIST_HEADER_COUPON_NO',
        couponName: 'PROMOTION_POPUP_USELIST_HEADER_COUPON_NAME',
        memberNo: 'PROMOTION_POPUP_USELIST_HEADER_MEMBER_NO',
        memberName: 'PROMOTION_POPUP_USELIST_HEADER_MEMBER_NAME',
        memberId: 'PROMOTION_POPUP_USELIST_HEADER_MEMBER_ID',
        memberGradeName: 'PROMOTION_POPUP_USELIST_HEADER_MEMBER_GRADE',
        couponDiscountAmt: 'PROMOTION_POPUP_USELIST_HEADER_COUPON_DISCOUNT',
        issueYmdt: 'PROMOTION_POPUP_USELIST_HEADER_REGISTER_YDMT',
        useYmdt: 'PROMOTION_POPUP_USELIST_HEADER_USE_YMDT'
      };
      keyMapJson = i18nAllObject(this, keyMapJson);
      let formatters = {};
      let fileName = `used_coupon_${changeDateFormat(new Date(), 'YYYYMMDD_HHmmss')}`;
      data.contents.forEach((item) => {
        (item as any).mallName = (this.couponInfo as any).mallName;
      });
      writeExcel(data.contents, keyMapJson, fileName, formatters);
    }
  }
  private gridProps = {
    options: {
      header: {
        height: 33,
        bacground: '#ccc'
      },
      columnOptions: {
        minWidth: 50,
        resizable: true
      },
      rowHeight: 'auto',
      minRowHeight: 30,
      displayRowCount: 30,
      isInitialRequest: true,
      useClientSort: false,
      pageOptions: {
        perPage: 30,
        page: 1,
        totalCount: 0
      },
      copyOptions: {
        useFormattedValue: true
      }
    },
    columnOptions: {
      useFormattedValue: true
    },
    showDummyRows: true,
    columns: [
      {
        header: 'PROMOTION_POPUP_USELIST_HEADER_MEMBER_NO',
        name: 'memberNo',
        align: 'center',
        minWidth: 80
        // formatter: function(data: any) {
        //   return `<a href="javascript:window.open(\'/member/popup/crm/${data.value}\',\'AccumulationPopup\',\'top=100, left=350, scrollbars=no, width=900, height=700, resizable=no\');" class="ordererPopup">${data.value}</a>`;
        // }
      },
      {
        header: 'PROMOTION_POPUP_USELIST_HEADER_MEMBER_NAME',
        name: 'memberName',
        align: 'center',
        minWidth: 80
      },
      {
        header: 'PROMOTION_POPUP_USELIST_HEADER_MEMBER_ID',
        name: 'memberId',
        align: 'center',
        minWidth: 80
      },
      {
        header: 'PROMOTION_POPUP_USELIST_HEADER_MEMBER_GRADE',
        name: 'memberGradeName',
        align: 'center',
        minWidth: 80
      },
      {
        header: 'PROMOTION_POPUP_USELIST_HEADER_COUPON_DISCOUNT',
        name: 'couponDiscountAmt',
        align: 'right',
        minWidth: 80,
        formatter: (data: any) => {
          if (data.value) {
            return data.value.toLocaleString();
          }
        }
      },
      {
        header: 'PROMOTION_POPUP_USELIST_HEADER_REGISTER_YDMT',
        name: 'issueYmdt',
        align: 'center',
        minWidth: 130
      },
      {
        header: 'PROMOTION_POPUP_USELIST_HEADER_USE_YMDT',
        name: 'useYmdt',
        align: 'center',
        minWidth: 130
      }
    ]
  };
}
